import { createReducer, on } from '@ngrx/store';

import { AuthState, initialAuthState } from '@ninety/mobile/platform/auth';

import { SessionActions } from './session.actions';

/**
 * Holds the auth machine's state, and nothing else.
 *
 * It does not call `transition()`. `transition()` returns `[AuthState, Command[]]` and a reducer
 * can only return the first element, so calling it here would drop the Commands — the entire
 * side-effect plan — on the floor. `SessionEffects` calls it and dispatches the result.
 *
 * This reducer therefore has no rules in it at all: every rule lives in `transition()`, where it is
 * tested by comparing two values.
 */
export const sessionReducer = createReducer<AuthState>(
  initialAuthState,
  on(SessionActions.stateAdvanced, (_, { state }): AuthState => state)
);
